import React from "react";
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBContainer,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBBtn,
  MDBRow,
  MDBCol ,
} from "mdb-react-ui-kit";

import "./VideoPlayerModal.css";

import Constantes from "Projects/CC_cubi_clan_project/Utils/Constantes";

export class VideoPlayerModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showVideoPlayerModal: false,
      mediaUrl: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.showVideoPlayerModal !== prevProps.showVideoPlayerModal) {
      this.setState({ showVideoPlayerModal: this.props.showVideoPlayerModal });
    }
    if (this.props.mediaUrl !== prevProps.mediaUrl) {
      let url = Constantes.URL_BASE + Constantes.URL_BOX + "stream";
      url = this.props.mediaUrl
        ? url + "?FileName=" + this.props.mediaUrl
        : null;
      this.setState({ mediaUrl: url });
    }
  }

  toggleShow = () => {
    this.setState({
      showVideoPlayerModal: !this.state.showVideoPlayerModal,
    });
    this.props.closeModal();
  };

  render() {
    return (
      <MDBModal show={this.state.showVideoPlayerModal} tabIndex="-1">
        <MDBModalDialog size='fullscreen'>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Video Player</MDBModalTitle>
              <MDBBtn
                className="btn-close"
                color="none"
                onClick={this.toggleShow}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <MDBContainer>
              <MDBRow className='mb-3'>
              <MDBCol size='12'>
              {this.state.mediaUrl ? (
                  <video controls autoPlay className="boxVideo">
                    <source src={this.state.mediaUrl} />
                    <p>Tu navegador no soporta la reproducción de videos.</p>
                  </video>
                ) : (
                  <></>
                )}
                </MDBCol>
              </MDBRow>
              </MDBContainer>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    );
  }
}
